import {Component, OnInit, OnDestroy, Output, EventEmitter} from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { EngineService} from '../_services/engine.service';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Subject} from 'rxjs';
import moment from 'moment';
import { startDateBeforeEndDate } from '../_services/date-picker-validator.service';
import {AuthService} from "../_services/auth.service";

@Component({
  templateUrl: './engine-stats-modal.component.html',
  styleUrls: ['./engine-stats-modal.component.css']
})

export class EngineStatsModalComponent implements OnInit, OnDestroy {

  public engine;
  engineId = -1;

  public startMin = "00:00";
  public startMax = "24:00";
  public endMin = "00:00";
  public endMax = "24:00";

  public form: FormGroup;
  public timeZones = [];

  @Output() reportStarted = new EventEmitter();

  private _onDestroy$: Subject<void> = new Subject();

  constructor(
    private authService: AuthService,
    private bsModalRef: BsModalRef,
    private engineService: EngineService,
    private fb: FormBuilder
    ) { }

  close() {
    this.bsModalRef.hide();
  }

  compare(val1, val2) {
    return val1 === val2;
  }

  ngOnInit() {

    this.authService.getAvailableTimeZones().subscribe(data => {
      this.timeZones = data
    });
    this.form = this.fb.group({
      timeZone: {},
      period: [{ startDate: new Date(2015, 0), endDate: new Date(2030, 0), isNew: false }, startDateBeforeEndDate()],
      startTime: '12:00',
      endTime: '12:00',
      uniqueDevices: [true] ,
      triggeredDevices: [true] ,
      misfiredDevices: [true],
      totalTriggers: [true],
      triggersHeard: [true],
      successfulTriggers: [true],
      misfires: [true],
      deviceTriggerSuccessRate: [true],
      totalEngineAuths: [true],
      uniqueEngineAuths: [true]
    });
  }

  private convertToUTCTime (date: Date, offset: string){

    const offsetNumber = +offset.slice(1,3);

    let hours = date.getHours();
    let formattedHours = "00";
    let minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes().toString();

    if (offset.startsWith('+')) {

      hours = (date.getHours() - offsetNumber) % 24;

    } else if (offset.startsWith('-')) {

      hours = (date.getHours() + offsetNumber) % 24;
    }

    formattedHours = (hours.toString().length === 1)? `0${hours}`: hours.toString();

    return `${formattedHours}:${minutes}`;
  }

  generateReport() {

    const timeDiff = this.timeZones["us"].find(timeZone => timeZone.Id === this.form.controls.timeZone.value) || this.timeZones['us'][0]

    const startTimeFromForm: Date =  new Date()
    startTimeFromForm.setHours(this.form.controls.startTime.value.slice(0,2))
    startTimeFromForm.setMinutes(this.form.controls.startTime.value.slice(3,5))

    const endTimeFromForm: Date =  new Date()
    endTimeFromForm.setHours(this.form.controls.endTime.value.slice(0,2))
    endTimeFromForm.setMinutes(this.form.controls.endTime.value.slice(3,5))

    this.form.controls.startTime.patchValue(this.convertToUTCTime(startTimeFromForm, timeDiff.BaseUtcOffset));
    this.form.controls.endTime.patchValue(this.convertToUTCTime(endTimeFromForm, timeDiff.BaseUtcOffset));

    const startDate = this.formatDate(this.form.controls.period.value.startDate);
    const endDate = this.formatDate(this.form.controls.period.value.endDate);
    
    const filterData = {
      ...this.form.getRawValue(),
      startDate,
      endDate,
      engineId: this.engine.engineId
    }

    this.engineService.filterEngineStats(filterData)
    .subscribe(() =>
      {
        this.reportStarted.emit(true);
        this.bsModalRef.hide();
      });
  }

  ngOnDestroy() {
    if (this._onDestroy$) {
      this._onDestroy$.next();
      this._onDestroy$.complete();
    }
  }

  private formatDate(date: Date): string {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
  }

}

